import each from 'lodash/each';
import reduce from 'reduce-object';

export const replaceAll = (from, to, str) => {
  to = to.replace(/\$/g, '$$$$');
  return str.replace(
    new RegExp(
      from.replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|<>\-\&])/g, '\\$&'),
      'g'
    ),
    to
  );
};

export const isNative = () => window.location.search.includes('native=true');

export const replaceMultipleInString = (replaceObject, string, inverse) => {
  let modified = string;

  each(replaceObject, (value, key) => {
    const to = inverse ? key : value;
    const from = inverse ? value : key;
    modified = replaceAll(from, to, modified);
  });

  return modified;
};

export const getMarkdownContent = data => {
  const IS_NATIVE = isNative();

  const elements = {
    div: 'View',
    span: 'Text',
    img: 'Image',
    button: 'Button',
    input: 'TextInput'
  };

  const others = {
    'onClick={': 'onPress={',
    'onChange={': 'onChangeText={',
    '`onChange`': '`onChangeText`'
  };

  const plain = {
    IS_WEB: (!IS_NATIVE).toString(),
    IS_NATIVE: IS_NATIVE.toString()
  };

  const allElementVariations = reduce(
    elements,
    (acc, to, from) => {
      acc[`</${from}>`] = `</${to}>`;
      acc[`<${from}`] = `<${to}`;
      acc[`<${from}/>`] = `<${to}/>`;
      return acc;
    },
    {}
  );

  const all = {
    ...allElementVariations,
    ...others
  };

  const webToNative = {
    'e.target.value': 'e'
  };

  data = replaceMultipleInString(all, data, !IS_NATIVE);
  data = replaceMultipleInString(plain, data);

  if (IS_NATIVE === true) {
    data = replaceMultipleInString(webToNative, data);
  }

  return data;
};



// WEBPACK FOOTER //
// ./src/utils/utils.js